export default {
  apartments: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'العمارات السكنية والعقارات',
    hero: {
      eyebrow: 'العمارات السكنية والعقارات',
      title: 'أمان لمبانٍ سكنية كاملة',
      lead: 'المدخل والسلالم والمرآب السفلي – نخطط مراقبة للعمارات تحمي المستأجرين وتمنح الملاك الطمأنينة.',
    },
    areas: {
      title: 'نقاط المراقبة في العمارة السكنية',
      lead: 'المناطق المشتركة هي أهم نقاط البداية. نراعي دائمًا حقوق جميع السكان.',
      items: {
        '0': { title: 'مدخل المبنى', desc: 'المدخل هو بطاقة تعريف المبنى وأهم نقطة مراقبة. الكاميرات تلتقط من يدخل.' },
        '1': { title: 'السلالم', desc: 'السلالم ممرات كثيرة الحركة. كاميرات مدمجة تسد الفجوات بين الطوابق دون لفت النظر.' },
        '2': { title: 'قبو الدراجات', desc: 'الدراجات والدراجات الكهربائية أهداف شائعة للسرقة. المراقبة تردع وتساعد في التوضيح.' },
        '3': { title: 'المرافق الخارجية', desc: 'الملاعب والمساحات الخضراء والممرات مشتركة. كاميرات مقاومة للطقس تحمي هنا أيضًا.' },
        '4': { title: 'المرآب السفلي', desc: 'مواقف المرآب السفلي معرضة للخطر ليلًا. المراقبة جيدة الإضاءة توفر الأمان.' },
        '5': { title: 'صناديق البريد', desc: 'صناديق البريد وخزائن الطرود محور سرقة الطرود. كاميرات الدخول تساعد كثيرًا.' },
      },
    },
    protection: {
      eyebrow: 'حماية البيانات والنظام الداخلي',
      title: 'راقب دون انتهاك',
      lead: 'تتقاطع مصالح كثيرة في العمارة السكنية. ننفّذ المراقبة بما يحترم خصوصية السكان ويظل قانونيًا.',
      items: {
        '0': { title: 'إخفاء المناطق الخاصة', desc: 'النوافذ وأبواب الشقق والمناطق الخاصة تُخفى تقنيًا – تبقى المناطق المشتركة فقط في الصورة.' },
        '1': { title: 'القرار والنظام الداخلي', desc: 'المراقبة في العمارة تحتاج أساسًا متينًا. ندعمك في التنفيذ النظيف.' },
        '2': { title: 'اللافتات الإرشادية', desc: 'إرشادات واضحة عند المدخل تعلم المستأجرين والزوار – بشفافية وإنصاف.' },
      },
    },
    value: {
      eyebrow: 'قيمة مضافة',
      title: 'مزايا للملاك والإداريين',
      lead: 'نظام مدروس يعود بالنفع على الجميع: يشعر المستأجرون بأمان أكبر، ويحمي الملاك أصولهم، ويحصل الإداريون على وضوح.',
      list: {
        '0': 'وصول للإداريين والملاك بحقوق منفصلة',
        '1': 'تسجيل الأيام أو الأسابيع الأخيرة – حسب إعدادات التخزين',
        '2': 'تخفيف العبء عن الإدارة في الحوادث والنزاعات',
        '3': 'توثيق كامل عند التخريب أو الاقتحام',
        '4': 'ردع الدخول غير المصرح به',
        '5': 'شعور أكبر بالأمان للمستأجرين والملاك',
      },
      note: 'ملاحظة: تعتمد شرعية المراقبة في المباني السكنية بشدة على الحالة الفردية. ننصحك دون أن نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'مزيد من الأمان لمبناك',
      lead: 'ننصح جمعيات الملاك والإداريين دون التزام – من الفكرة الأولى إلى النظام الجاهز.',
      primary: 'احجز موعد استشارة',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
};